// src/components/ui/Header.jsx
import React, { useEffect, useState, useRef } from "react";
import { getDisplayName, signOut } from "../../lib/cognito";

export default function Header() {
  const [displayName, setDisplayName] = useState("User");
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    getDisplayName().then((name) => {
      if (name) setDisplayName(name);
    });
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => {
    signOut();
    window.location.href = "/login-screen";
  };

  return (
    <header
      className="flex justify-between items-center px-6 py-4 
                 bg-black/20 backdrop-blur-xl 
                 border-b border-white/20
                 shadow-[0_1px_2px_rgba(0,0,0,0.15)]
                 transition-all"
    >
      {/* Logo */}
      <div className="flex items-center gap-3 cursor-default select-none">
        <img
          src="/assets/images/graftcounter-logo.png"
          alt="Graft Counter Logo"
          className="w-9 h-9 object-contain rounded-xl"
        />
        <span className="text-xl font-semibold tracking-tight text-white/90">
          Graft Counter
        </span>
      </div>

      {/* User Menu */}
      <div className="relative" ref={menuRef}>
        <button
          onClick={() => setMenuOpen((p) => !p)}
          className="flex items-center gap-2 text-white/90 font-medium 
                     hover:opacity-70 transition"
        >
          {/* Inline SVG (works in Safari always) */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5 opacity-90"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="1.6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5.121 17.804A9 9 0 0112 15a9 9 0 016.879 2.804M15 10a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>

          {displayName}

          <span
            className={`transition-transform ${
              menuOpen ? "rotate-180" : ""
            }`}
          >
            ▼
          </span>
        </button>

        {menuOpen && (
          <div
            className="absolute right-0 mt-2 w-40 
                       bg-white/90 backdrop-blur-xl 
                       shadow-lg border border-gray-200/50 
                       rounded-lg text-sm overflow-hidden animate-fadeIn"
          >
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 hover:bg-gray-100/60 transition"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
